import React from 'react'
import { Case, Default, Switch } from 'react-if'
import { SceneIcon } from '@/atoms/Icons/SceneIcon'
import { CaptionSM } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface CollectibleSceneLabelProps {
  type?: 'GOLDEN' | 'COMMON' | null
}

export const CollectibleSceneLabel: React.FC<CollectibleSceneLabelProps> = ({ type }) => {
  const { t } = useTranslate('watch')

  return (
    <div className="mb-1 flex items-center">
      <Switch>
        <Case condition={type === 'GOLDEN'}>
          <SceneIcon size={20} color1="collectible-gold" color2="black" />
          <CaptionSM weight="bold" className="ml-1" color="collectible-gold">
            {t('goldenScene', 'Golden Scene')}
          </CaptionSM>
        </Case>
        <Default>
          <SceneIcon size={20} color1="collectible-blue" color2="black" />
          <CaptionSM weight="bold" className="ml-1" color="collectible-blue">
            {t('collectibleScene', 'Collectible Scene')}
          </CaptionSM>
        </Default>
      </Switch>
    </div>
  )
}
